export const SUPPORT_EMAIL = "support@wilmactech.com";
